/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { settings } from 'config/config';
import { environment, integration, pageurl, device, parentWindow } from 'utils/environment';
import { log } from 'utils/logger';



/* .......... REFRESH ADs .......... */
let adsToIgnoreForRefresh = [];
const refreshAds = (timeout=0) => {
    log('::::: ads refresh requested');
    if (environment === 'LOCALHOST') { log('::::: not refreshing ads // localhost'); return null; }
    const postContent = {
        action: "refreshAd",
        domain: pageurl,
        hoverUnits: adsToIgnoreForRefresh, // [], ['TOP'], ['BOTTOM'] or ['TOP', 'BOTTOM'] //contains units that will _not_ be refreshed
    };
    log('::::: postContent', postContent);
    let timer = setTimeout(() => {
        log('::::: postContent', postContent);
        parentWindow.postMessage(postContent, "*");
        clearTimeout(timer);
    }, timeout);
};



/* .......... STORE EMBED CONTAINER DIVs .......... */
const embedId = `embedid-${settings.embed.uuid}`;
let embedDiv = !!window.frameElement ? window.frameElement.parentElement : parentWindow.document.getElementById('insticator-embed');
let containerDiv = !!embedDiv ? embedDiv.parentElement : parentWindow.document.querySelector('#insticator-container');
let containerReference = `#insticator-container.${embedId}`;
let embedReference = '#insticator-embed';

/* .......... STORE AD DIVs .......... */
const adDivs = [];
if(!!containerDiv) {
    containerDiv.querySelectorAll('div').forEach(node => {
        if(node.id.includes('div-insticator-ad-')) adDivs.push(node)
    })
}

/* .......... LOCAL TESTING ONLY!!! (create & store ad divs) .......... */
// temp add position to the body to simulate being inside the container
if ((environment === 'LOCALHOST') && (pageurl.includes(':3000'))) {
    // was using "!settings.project" check to ensure we're local widget project only ... because MKS ("the-new-dashboard") uses a preview of this widget, and since it runs on localhost, this code would run and create unwanted dummy ads
    // now using :3000 to check the port since B2C will also have embeds inside it
    log('local widget project');
    // reset vars with different elements
    containerDiv = parentWindow.document.querySelector('body');
    embedDiv = parentWindow.document.getElementById('app');
    containerReference = `body.${embedId}`;
    embedReference = '#app';
    
    // generate temporary external ad for testing styles
    adDivs.forEach((adDiv, i) => {
      adDiv.setAttribute('style', 'width:300px; height:250px; background:#ccc; outline:1px solid #000;');
      adDiv.innerHTML = `Ad ${i + 1}`;
    })
}


const topAdId = !!adDivs[0] && !!adDivs[0].id ? `#${adDivs[0].id}` : `#div-insticator-ad-1`;
const bottomAdId = !!adDivs[1] && !!adDivs[0].id ? `#${adDivs[1].id}` : `div-insticator-ad-2`;
let adsToOverlay = [];


/* .......... STYLE TEMPLATES FOR ADs .......... */
// ad display types: REGULAR, OVERLAY_TOP_AD, OVERLAY_BOTTOM_AD, BOTH_OVERLAY_ADS
// AD STYLES - REGULAR GENERAL
const generalAdStyles = `
    /* ..... GENERAL AD STYLES ..... */
    ${containerReference} ${topAdId},
    ${containerReference} ${bottomAdId} { margin: 0 auto; }
`;
// AD STYLES - OVERLAY GENERAL
const overlayGeneralStyles = `opacity: 0; position: absolute; left: 50%; z-index: -1; transition: opacity 500ms linear 0ms; display: none;`;
// AD STYLES - OVERLAYs
const overlayAdStyles = `
    /* ..... OVERLAY - GENERAL ..... */
    /* ___container level styles___ */
    ${containerReference} { position: relative; }
    ${containerReference} ${embedReference} { position: relative; z-index: 1; }
    
    /* ___apply overlay style to correct ad___ */
    ${containerReference}.OVERLAY_TOP_AD ${topAdId},
    ${containerReference}.BOTH_OVERLAY_ADS ${topAdId} { ${overlayGeneralStyles} top: ${parseInt(settings.embed.styles[device].height, 10)/2}px; transform: translate(-50%, -50%); }
    ${containerReference}.OVERLAY_BOTTOM_AD ${bottomAdId},
    ${containerReference}.BOTH_OVERLAY_ADS ${bottomAdId} { ${overlayGeneralStyles} bottom: ${parseInt(settings.embed.styles[device].height, 10)/2}px; transform: translate(-50%, 50%); }

    /* ___display ads___ */
    ${containerReference}.OVERLAY_TOP_AD.showOverlayAds ${topAdId},
    ${containerReference}.OVERLAY_BOTTOM_AD.showOverlayAds ${bottomAdId} { display: block; }

    /* ___animate to visible___ */
    ${containerReference}.OVERLAY_TOP_AD.animateAdVisible ${topAdId},
    ${containerReference}.OVERLAY_BOTTOM_AD.animateAdVisible ${bottomAdId},
    ${containerReference}.BOTH_OVERLAY_ADS.animateAdVisible ${topAdId},
    ${containerReference}.BOTH_OVERLAY_ADS.animateAdVisible ${bottomAdId} { opacity: 1; z-index: 2; }
`;
// AD STYLES - IN CONTENT - BOTH OVERLAY
const inContentBothOverlayAdStyles = `
    /* ..... IN CONTENT - BOTH OVERLAY ..... */
    /* ___theres enough space, show both ads as overlays___ */
    @media screen and (min-width: 600px) {
        ${containerReference}.showOverlayAds ${topAdId} { display: block; margin-left: -${adDivs[0] ? 150 : 0}px; }
        ${containerReference}.showOverlayAds ${bottomAdId} { display: block; margin-left: ${adDivs[1] ? 150 : 0}px; }
    }
    /* ___hide one ad, since not enough space for two___ */
    @media screen and (max-width: 599px) {
        ${containerReference}.showOverlayAds ${topAdId} { display: block; margin-left: auto; }
        ${containerReference}.showOverlayAds ${bottomAdId} { display: none; }
    }
`;
// AD STYLES - IN CONTENT - REGULAR
const inContentRegularAdStyles = `
    /* ..... IN CONTENT - REGULAR ..... */
    /* ___flex the container so we can move ad position order around___ */
    ${containerReference} { position: relative; display: flex; flex-flow: row wrap; justify-content: center; }
    /* ___order divs___ */
    ${containerReference} ${embedReference} { width: 100%; order: 1; }
    ${containerReference} ${topAdId} { order: 2; }
    ${containerReference} ${bottomAdId} { order: 3; }
    /* ___adjust ads so there's no space___ */
    ${containerReference} ${topAdId},
    ${containerReference} ${bottomAdId} { display: inline-block; margin: 0; }
`;



/* .......... CREATE STYLESHEET .......... */
const createStyleSheetForAds = (passedStyles) => {
    var css = parentWindow.document.createElement("style");
    css.type = "text/css";
    css.innerHTML = passedStyles;
    containerDiv.appendChild(css);
};



/* .......... SHOW OVERLAY ADs .......... */
// this function is called from the components/content/ad component when it's active or inactive (this is usually an injectable or can be in the actual queue in settings file)
const showOverlayAds = (show=true) => {
    // ensure we actually have a container DIV in the page before trying to manipulate ads
    if ((containerDiv) && (adDivs)) {
        // show or hide appropriate ads
        if (adsToOverlay.length > 0) {
            // first modify display property so no fraud (make sure non-visible ads are display none)
            switch (show) {
                case true:
                    containerDiv.classList.add('showOverlayAds');
                    setTimeout(() => { containerDiv.classList.add('animateAdVisible') }, 100);
                    break;
                case false:
                default:
                    containerDiv.classList.remove('showOverlayAds', 'animateAdVisible');
                    break;
            }
        }
    }
};



/* !!!!!! ~~~~~~~~~~~~~~~~~~~~ INITIALIZE ADs ~~~~~~~~~~~~~~~~~~~~ !!!!!! */
// ad is actually in the settings file and used as injectable, this is how we place the ad in the queue and flow of the app, that content can be found in components/content/ad
if ((settings.embed.ads) && (containerDiv) && (adDivs)) {
    // add ad display type to container so we can style correctly
    containerDiv.classList.add(embedId, settings.embed.ads.display[device]);
    // handle ad type cases
    switch (settings.embed.ads.display[device]) {
        case 'OVERLAY_TOP_AD':
            log('OVERLAY_TOP_AD');
            adsToIgnoreForRefresh = ['TOP'];
            adsToOverlay.push(adDivs[0]);
            createStyleSheetForAds(generalAdStyles + overlayAdStyles);
            break;
        case 'OVERLAY_BOTTOM_AD':
            log('OVERLAY_BOTTOM_AD');
            adsToIgnoreForRefresh = ['BOTTOM'];
            adsToOverlay.push(adDivs[1]);
            createStyleSheetForAds(generalAdStyles + overlayAdStyles);
            break;
        case 'BOTH_OVERLAY_ADS':
            log('BOTH_OVERLAY_ADS');
            adsToIgnoreForRefresh = ['TOP', 'BOTTOM'];
            adDivs.forEach(loopedAd => adsToOverlay.push(loopedAd));
            createStyleSheetForAds(overlayAdStyles + inContentBothOverlayAdStyles);
            break;
        case 'REGULAR':
        case 'BOTH_BOTTOM_ADS': // just added from BE based on workflow, may need to blow out in the future
        default:
            log('REGULAR');
            settings.embed.location === 'RAIL' ? createStyleSheetForAds(generalAdStyles) : createStyleSheetForAds(inContentRegularAdStyles);
            break;
    };
}



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export { refreshAds, showOverlayAds };
